import React, { useState, useEffect } from 'react';

import {  FaCog, FaSignOutAlt, FaLifeRing, FaBan  } from 'react-icons/fa';


import avatar1 from '../../client/Components/Assets/avatar1.png';
import avatar2 from  '../../client/Components/Assets/avatar2.png';
import avatar3 from  '../../client/Components/Assets/avatar3.png';
import avatar4 from  '../../client/Components/Assets/avatar4.png';
import avatar5 from  '../../client/Components/Assets/avatar5.png';
import avatar6 from  '../../client/Components/Assets/avatar6.png';
import avatar7 from  '../../client/Components/Assets/avatar7.png';
import avatar8 from  '../../client/Components/Assets/avatar8.png';
import avatar9 from  '../../client/Components/Assets/avatar9.png';
import avatar10 from  '../../client/Components/Assets/avatar10.png';
import avatar11 from  '../../client/Components/Assets/avatar11.png';
import avatar12 from  '../../client/Components/Assets/avatar12.png';



import profileImg from '../Assets/Images/profileImg.png';


const NavAvatar = ({ user, onLogout, supportServices, setSupportServices }) => {
   
  const { name = '', picture = null } = user || {};
  const [selectedAvatar, setSelectedAvatar] = useState(picture || profileImg);
  const [showAvatarSelector, setShowAvatarSelector] = useState(false); 
  const [showPreferences, setShowPreferences] = useState(false); 
  
  // Use the imported images directly
  const defaultAvatars = [
    { id: 1, src: avatar1 },
    { id: 2, src: avatar2 },
    { id: 3, src: avatar3 },
    { id: 4, src: avatar4 },
    { id: 5, src: avatar5 },
    { id: 6, src: avatar6 },
    { id: 7, src: avatar7 },
    { id: 8, src: avatar8 },
    { id: 9, src: avatar9 },
    { id: 10, src: avatar10 },
    { id: 11, src: avatar11 },
    { id: 12, src: avatar12 }
 

  ];

  const handleAvatarSelect = (avatarSrc) => {
    setSelectedAvatar(avatarSrc);
    setShowAvatarSelector(false); 
    localStorage.setItem('selectedAvatar', avatarSrc);
  
    // Send the avatar URL to the service worker for caching
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'CACHE_AVATAR',
        avatarUrl: avatarSrc // This is already a URL generated by Webpack
      });
    }
  };

  


  const formatName = (fullName) => {
    if (!fullName.trim()) return 'User';
    
    const [first, ...last] = fullName.split(' ');
    
    // Capitalize first letter of first name and handle empty cases
    const formattedFirst = first && first[0] 
      ? `${first[0].toUpperCase()}.`
      : '';
    
    // Capitalize first letter of last name(s) while preserving the rest
    const formattedLast = last
      .filter(namePart => namePart.trim())
      .map(namePart => 
        namePart[0].toUpperCase() + namePart.slice(1).toLowerCase()
      )
      .join(' ');

    return `${formattedFirst} ${formattedLast}`.trim();
  };
  const togglePreferences = () => {
    setShowPreferences(!showPreferences);
  };
  const handleSupportToggle = (isEnabled) => {
    setSupportServices(isEnabled);
    setShowPreferences(false);

  };

  useEffect(() => {
    const savedAvatar = localStorage.getItem('selectedAvatar');
    if (savedAvatar) {
      setSelectedAvatar(savedAvatar);
    }
  }, []);




  return (
    <div className="avatar-wrap">
      {/* Profile Image */}
      <img 
        src={selectedAvatar} 
        alt="Profile" 
        className="admin-profile-circle" 
        onClick={() => setShowAvatarSelector(true)}
        onError={(e) => e.target.src = profileImg}
      />
      
      {/* Dropdown */}
      <div className="nav-item dropdown pe-3">
        <a 
          className="nav-profile dropdown-toggle" 
          href="#" 
          id="userDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span className="nav-avatar-name">
            {formatName(name)}
          </span>
        </a>
        
        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
          {!picture && (
            <li>
              <a 
                className="dropdown-item" 
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowAvatarSelector(true);
                }}
              >
            
              </a>
            </li>
          )}
          <li>
            <a 
              className="dropdown-item" 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                onLogout();
              }}
            >
              <FaSignOutAlt /> Logout
            </a>
          </li>

          <li><hr className="dropdown-divider" /></li>

          <li>
            <a 
              className="dropdown-item" 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowPreferences(!showPreferences);
              }}
            >
              <FaCog /> Preferences
            </a>
          </li>

          {showPreferences && (
            <>
              <li>
                <a 
                  className="dropdown-item ps-4" 
                  href="#" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleSupportToggle(true);
                  }}
                >
                  <FaLifeRing className="enable-support-icon"  /> Enable Support
                </a>
              </li>
              <li>
                <a 
                  className="dropdown-item ps-4" 
                  href="#" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleSupportToggle(false);
                  }}
                >
                  <FaBan className="disable-support-icon"  /> Disable Support 
                </a>
              </li>
            </>
          )}
        </ul>
      </div>

      {/* Avatar Selector Popup */}
      {showAvatarSelector && (
        <div 
          className="avatar-selector-popup"  
          onClick={() => setShowAvatarSelector(false)}
        >
          <div 
            className="avatar-grid-container" 
            onClick={(e) => e.stopPropagation()}
          >
            <h6>Select an Avatar</h6>
            <div className="avatar-grid">
              {defaultAvatars.map(avatar => (
                <img
                  key={avatar.id}
                  src={avatar.src}
                  alt={`Avatar ${avatar.id}`}
                  className="avatar-option"
                  onClick={() => handleAvatarSelect(avatar.src)}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavAvatar;